import { ApiClient } from '@/lib/apiClient';
import type { CreateInbound, Inbound } from '@/types/inbound';

export default class InboundService extends ApiClient<Inbound, CreateInbound> {

  constructor() {
    super('/v1/inbound', 'number');
  }
}
